module.exports = "/_next/static/images/c1523f36dfe514d3fa19f246ddb51fd3-creditsprd-lg.jpg";